import React from 'react';
import type { StatusVariant } from './StatusBadge';

type Props = {
  label: string;
  value: string | number;
  variant?: StatusVariant;
};

export default function MetricChip({ label, value, variant }: Props) {
  const variantClass = variant ? `metric-chip--${variant}` : '';
  return (
    <div className={`metric-chip ${variantClass}`.trim()} role="group" aria-label={`${label}: ${value}`}>
      <span className="metric-chip__label">{label}</span>
      <span className="metric-chip__value">{value}</span>
    </div>
  );
}
